import { Component, inject } from '@angular/core';
import { Entity } from '@app/core/model/entities/entity';
import { ContractsService } from '@app/features/main/views/organization-contracts/contracts.service';
import {
  ServerSideIndicatorStatusPanelComponent
} from '@app/shared/components/indicator-status-panel/server-side-indicator-status-panel/server-side-indicator-status-panel.component';
import { SelectParams } from '@app/shared/grid/datasource-utils';
import { IStatusPanelParams } from 'ag-grid-community';
import { merge, Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Component({
  selector: 'contracts-indicator-status-panel',
  templateUrl: '../indicator-status-panel.component.html',
  styleUrls: ['../indicator-status-panel.component.scss'],
  standalone: false
})
export class ContractsIndicatorStatusPanelComponent extends ServerSideIndicatorStatusPanelComponent {
  private contractsService = inject(ContractsService);

  /**
   * Set gridApi and add listen for row updates.
   */
  public agInit(params: IStatusPanelParams<Entity>): void {
    super.agInit(params);

    merge(
      this.contractsService.contractAdded$,
      this.contractsService.contractUpdated$,
      this.contractsService.contractsDeleted$,
      this.contractsService.contractRenewed$
    )
      .subscribe(() => this.updateIndicatorsValues());
  }

  /**
   * Get aggregation result.
   * @param selectParams The parameters for the query. These include filtering, and aggregating.
   * @return Observable<Entity> Result of the aggregation query.
   */
  protected getAggregationResult(selectParams: SelectParams): Observable<Entity> {
    return this.contractsService.loadContractsPage(selectParams)
      .pipe(first(), map(contracts => contracts.first()));
  }
}
